import jwtDecode from "jwt-decode";
import { isTokenAboutToExpire, isTokenExpired } from "~/assets/js/isTokenExpired";

const AUTH_ENDPOINTS = ["login", "auth/refresh", "auth/logout", "auth/code"];
const PRE_AUTH_ROLES = ["PRE_AUTH_CODE", "PRE_AUTH_SECRET"];

function isAuthRequest(url) {
  return AUTH_ENDPOINTS.some((endpoint) => url && url.includes(endpoint));
}

function isPreAuthToken(token) {
  try {
    return PRE_AUTH_ROLES.includes(jwtDecode(token).roles);
  } catch {
    return false;
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default async function ({ $axios, app, store }, redirect) {
  let refreshPromise = null;

  await $axios.onRequest(async (config) => {
    if (!isAuthRequest(config.url)) {
      const token = store.getters["authentication/getAuthToken"];
      if (token && isTokenAboutToExpire(token) && !isPreAuthToken(token)) {
        if (!refreshPromise) {
          refreshPromise = store.dispatch("authentication/refreshAuthToken").finally(() => {
            refreshPromise = null;
          });
        }
        await refreshPromise;
      }
    }

    const currentToken = store.getters["authentication/getAuthToken"];
    if (currentToken) {
      config.headers.Authorization = currentToken;
    }

    return config;
  });

  await $axios.onError(async (error) => {
    const code = parseInt(error.response && error.response.status);

    if (code === 403 && !isAuthRequest(error.config?.url)) {
      const token = store.getters["authentication/getAuthToken"];
      if (isTokenExpired(token)) {
        if (!error.config.__retryCount) {
          error.config.__retryCount = 0;
        }

        if (error.config.__retryCount >= 3) {
          return Promise.reject(error);
        }

        error.config.__retryCount += 1;

        await store.dispatch("authentication/refreshAuthToken");
        const newToken = store.getters["authentication/getAuthToken"];

        error.config.headers.Authorization = newToken;
        return $axios.request(error.config);
      }
    }

    if (code === 418) {
      store.dispatch("authentication/cleanup");
      app.router.push("/login");
    }

    return Promise.reject(error);
  });
}
